import { HermesAnalytics } from '@workivate/tho-web-shared';
import { isManulifeFeatureEligible } from 'globals/manulife';

export const getGASectionFromUrl = (url?: string) => {
  return HermesAnalytics.getGASectionFromUrl(url ?? '');
};

export const isManulifeEventsEnabled = () => !!isManulifeFeatureEligible();
